module.exports = __webpack_public_path__ + "img/error_round_blue.99f04b65.svg";